// eslint-disable-next-line jira/filename-case
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useCommsFeatures } from './useCommsFeatures.tsx';
import { FEATURES } from '../constants/features.tsx';

export const PERMISSION_STATE = {
	LOADING: 'LOADING',
	TRUE: 'TRUE',
	FALSE: 'FALSE',
} as const;
type PermissionState = (typeof PERMISSION_STATE)[keyof typeof PERMISSION_STATE];

export const usePermissions = (
	featureName: string,
): {
	hasAccess: PermissionState;
	hasWriteAccess: boolean;
	isDraftOnly: boolean;
} => {
	const isAdmin = useIsAdmin();
	const { loading, features } = useCommsFeatures();

	let hasAccess: (typeof PERMISSION_STATE)[keyof typeof PERMISSION_STATE] =
		PERMISSION_STATE.LOADING;

	if (loading) {
		hasAccess = PERMISSION_STATE.LOADING;
	} else if (features[featureName]) {
		hasAccess = PERMISSION_STATE.TRUE;
	} else {
		hasAccess = PERMISSION_STATE.FALSE;
	}

	const hasWriteAccess = isAdmin === true;
	const isDraftOnly = fg('status_page_premium_exp_kill_switch')
		? (features[FEATURES.STATUS_PAGES_DRAFT_ONLY] ?? false)
		: false;

	return { hasAccess, hasWriteAccess, isDraftOnly };
};
